<template>
  <b-container style="margin-top:15px">
    <b-row v-loading="loading">
      <b-card-group deck>
        <b-card header="Admin Düzenle" header-tag="header">
            <b-row>
              <b-col cols="3">
                  <b-form-group label="İsim">
                    <b-form-input size="sm" v-model="form.name" placeholder="İsim"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Soyisim">
                    <b-form-input size="sm" v-model="form.surname" placeholder="Soyisim"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Email">
                    <b-form-input type="email" size="sm" v-model="form.email" placeholder="Email"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Şifre">
                    <b-form-input type="password" size="sm" v-model="form.password" placeholder="Şifre"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Telefon">
                    <b-form-input type="number" size="sm" v-model="form.phone" placeholder="Telefon"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Vergi Dairesi">
                    <b-form-input size="sm" v-model="form.tax" placeholder="Vergi Dairesi"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Vergi Numarası">
                    <b-form-input type="number" onKeyDown="if(this.value.length==10 && event.keyCode!=8) return false;"  size="sm" v-model="form.tax_number" placeholder="Vergi Numarası"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Adres">
                    <b-form-input size="sm" v-model="form.address" placeholder="Adres"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="TC Kimlik Numarası">
                    <b-form-input type="number" onKeyDown="if(this.value.length==11 && event.keyCode!=8) return false;"  size="sm" v-model="form.identity_id" placeholder="TC Kimlik Numarası"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Yetki Grubu">
                    <b-form-select size="sm" v-model="form.roles" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option :value="item.id" v-for="(item,key) in roles" :key="key">{{ item.name }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group style="margin-top:29px">
                    <b-button @click="send()" style="width:100%" variant="primary" size="sm">Güncelle</b-button>
                  </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'AdminsDetail',
    data(){
      return{
        id: this.$route.params.id,
        loading: false,
        roles:[],
        form:{
        }
      }
    },
    created(){
      this.fetchRoles();
      this.fetch();
    },
    methods:{
      fetchRoles(){
        axios.get('/admin/roles')
        .then((response) => {
            this.roles = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
        });
      },
      fetch(){
        this.loading = true;
        axios.get('/admin/' + this.id + '/detail')
        .then((response) => {
            this.form = response.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
      send(){
        this.loading = true;
        axios.post('/admin/' + this.form.id + '/update', this.form)
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'success', title: 'Güncelleme Başarılı'});
            this.$router.push({name: 'Admins'});
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
    }
  }
</script>